import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { getItemType, addItemType, deleteItemType, updateItemType } from "../../redux/actions/itemType.action";
import { getDefaultCompany, getOneDefaultCompany } from "../../redux/actions/defaultCompany";
import { getCompanyAccess, updateCompanyAccess, deleteCompanyAccess, getAllCompany, createCompanyAccess } from "../../redux/actions/companyAccess"
import { getLog } from "../../redux/actions/log.action"
import { getRights } from "../../redux/actions/userRights.action";

import PageHeader from "../../components/PageHeader/PageHeader"
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import Tables from "../../components/Table/Tables"
import { ReadCookie } from "../../utils/readCookie";
import { Button, Row, Col, Form, Input, Checkbox, Tabs, Tooltip, Popconfirm, Modal, Divider } from 'antd';
import { CloseCircleOutlined, DeleteOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { logColumns, itemTypeColumns } from "../../utils/cols";
import notification from '../../utils/notification';
import "../Style/style.css";
import { TabTitle } from '../../utils/GeneralFunction';

const { TabPane } = Tabs;

export default function ItemType({ token }) {
    TabTitle("Item Type")
    const menuId = ReadCookie('menuId')
    const dCompanyId = ReadCookie('defaultCompany')
    const itemTypeNameInput = useRef(null);
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();
    const [itemTypeObj, setItemTypeObj] = useState(null);
    const dispatch = useDispatch();
    const { itemType, getDemoDefaultCompany, companyAccess, companyAll, log, userRights } = useSelector(state => state)
    // const stateData = useSelector(state => state)
    const [minimize, setMinimize] = useState(false);
    const [check, setCheck] = useState(false);
    const [itemTypeName, setItemTypeName] = useState('');
    const [disable, setDisable] = useState(false);
    const [formState, setFormState] = useState('view');

 


    useEffect(() => {
        dispatch(getItemType(token, menuId));
        // dispatch(getLog(token));
        dispatch(getLog(token, { inv_style: "inv_style"}))
      }, [token]);
    

    // useEffect(() => {
    //     dispatch(getDefaultCompany(token));
    // }, [token])


    useEffect(() => {
        dispatch(getItemType(token, menuId))
    }, [token])

    useLayoutEffect(() => {
        dispatch(getRights(token, menuId)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])

    useEffect(() => {

        if (itemTypeObj) {
            setFormState('view')
            form.setFieldsValue({
                id: itemTypeObj.item_type_id,
                itemType: itemTypeObj.item_type_name,
                active: itemTypeObj.is_active
            });
            setItemTypeName(itemTypeObj.item_type_name)
            setCheck(itemTypeObj.is_active)
            dispatch(getCompanyAccess(token, itemTypeObj.item_type_id, menuId))

        }
    }, [itemTypeObj]);

    useEffect(() => {
        if (itemTypeName === '') {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [itemTypeName])

    const showModal = () => {
        dispatch(getAllCompany(token));
        setVisible(true);
    };

    const handleOk = () => {
        setVisible(false);
    };

    const handleCancel = () => {
        setVisible(false);
    };
    const handleTab = (key) => {
        if (key === "logs") {
            // data: { inv_style: "inv_style", admin_company_entity_access: "admin_company_entity_access" }
            dispatch(getLog(token, { inv_style: "inv_style", admin_company_entity_access: "admin_company_entity_access" }))
        }
    }


    const formSave = () => {
        if (formState === "add") {
            dispatch(addItemType(token, { itemTypeName, check }, menuId)).then((res) => {

                if (res.type === "ADD_ITEMTYPE_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data)
                }
                if (res.type === "ADD_ITEMTYPE_SUCCESS") {
                    let data = {
                        company_id: dCompanyId
                    }
                    notification("success", "Item Type Created", "Item Type created successfully!");
                    form.setFieldsValue({
                        itemType: ""
                    })
                    setFormState("")
                    // setCheck(false)
                    setItemTypeName("")
                    setItemTypeObj(null)
                }
                dispatch(getItemType(token, menuId))

            })

        }

        if (formState === "edit") {
            dispatch(updateItemType(token, { itemTypeName, check }, itemTypeObj.item_type_id)).then((res) => {
                if (res.type === "UPDATE_ITEMTYPE_ERROR") {
                    notification("error", "Update", "Something went wrong")
                }
                if (res.type === "UPDATE_ITEMTYPE_SUCCESS") {
                    notification("success", "Item Type Updated", "Record updated successfully")
                }
                dispatch(getItemType(token, menuId))
            })


        }


    }

    const handleDelete = () => {
        if (itemTypeObj) {
            dispatch(deleteItemType(token, itemTypeObj.item_type_id)).then((res) => {
                if (res.type === "DELETE_ITEMTYPE_SUCCESS") {
                    notification("success", "Item Type Deleted", "Item Type deleted successfully!");
                }
                if (res.type === "DELETE_ITEMTYPE_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    itemType: ""
                })
                // setCheck(false)
                setItemTypeName("")
                setItemTypeObj(null)
                setFormState('')
                dispatch(getItemType(token, menuId))

            })
        }
    }
    useEffect(() => {
        if (formState === "add") {
            dispatch(getOneDefaultCompany(token, dCompanyId));
            itemTypeNameInput.current.focus();
            form.setFieldsValue({
                itemType: ""
            })
            setCheck(true)
            setItemTypeName("")
            setItemTypeObj(null)
        }
    }, [formState]);

    const filterReset = () => {
        setFormState("view")
    }
    return (
        <div className='styleContainer' >
            <div className='styleBody h-100'  >
                <PageHeader title={"Item Type"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle' >
                        <div className='crudDiv' ><CrudButtons rights={userRights?.payload} reset={filterReset} formType={formState} save={formSave} disable={disable} formState={setFormState} onDelete={handleDelete} /></div>

                        <div className='styleContent' >
                            <Row className='tables-main-row-new' >
                            <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                                    <div className='styleTable' >
                                        <Tables type="itemType" itemTypeObj={setItemTypeObj} scrollX={"20rem"} scroll={602} perPage={25} source={itemType?.payload?.data} col={itemTypeColumns} paginate load={itemType.loading} />
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                                    <div className='styleForm'  >
                                        <Form
                                            form={form}
                                            name="basic"
                                            labelCol={{ span: 12 }}
                                        >
                                             <div className='customRow styleFormUpper ' >
                                            {itemTypeObj !== null && !(formState === "add") &&
                                            <div className='customCols slc'>
                                                <Form.Item
                                                    label="ID"
                                                    name="id"
                                                    labelCol={{ span: 10 }}
                                                    wrapperCol={{ span: 14 }}
                                                    initialValue={form.getFieldValue().id}
                                                >
                                                    <Input  size='small' className='styleInput id-field-style' readOnly />

                                                </Form.Item>
                                                </div>
                                            }
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="Item Type"
                                                name="itemType"
                                                labelCol={{ span: 10 }}
                                                wrapperCol={{ span: 14 }}
                                                initialValue={form.getFieldValue().itemType}
                                            >

                                                <Input  size='small' disabled={!(formState === "add" || formState === "edit")} ref={itemTypeNameInput} onChange={(e) => setItemTypeName(e.target.value)} className='styleInput' />
                                            </Form.Item>
                                            </div>
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="Active"
                                                labelCol={{ span: 10 }}
                                                wrapperCol={{ span: 14 }}
                                                name="active"
                                            >
                                                <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)} />
                                            </Form.Item>
                                            </div>
                                            </div>
                                        </Form>
                                
                                        <Divider />
                                        <div className='styleTab' >
                                            <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered onChange={(key) => handleTab(key)}>
                                         
                                                <TabPane tab="Log Info" key="logs"  >
                                                    <div className='tabs' >
                                                        <Tables type="company" scrollX={"50rem"} scroll={360} perPage={15} source={log?.payload?.data} col={logColumns} load={log.loading} paginate />
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                   
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                }

            </div>
            {
                minimize &&
                <div className='styleFooter' >
                    <Button className='minimize-button-style' onClick={() => setMinimize(false)}  >Style</Button>
                </div>
            }
        </div >
    )
}